import { useLocation } from 'react-router-dom';

import { Pages } from '@/pages';

const EDIT_ROUTE_PATTERN = new RegExp(
  `/${Pages.DOCUMENTS_AND_ACTS}/[a-f0-9-]+$`,
);

export const useShowEditButton = () => {
  const { pathname } = useLocation();
  return EDIT_ROUTE_PATTERN.test(pathname);
};
